import React, { useState } from "react";

const Navbar = ({ activeTab, onTabChange, planLimits }) => {
  const [open, setOpen] = useState(false);
  const metricsLocked = !(planLimits?.canAccessMetrics ?? false);

  const navItems = [
    { id: "invoices", label: "Invoices" },
    {
      id: "metrics",
      label: metricsLocked ? "Metrics (Pro)" : "Metrics",
      locked: metricsLocked,
    },
    { id: "profile", label: "Profile" },
  ];

  return (
    <header className="sticky top-0 z-30 border-b bg-white/80 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:py-4">
        <div className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-black text-sm font-semibold text-white">
            IU
          </div>
          <div className="flex flex-col leading-tight">
            <span className="text-base font-semibold text-slate-900">
              InvoiceU
            </span>
            <span className="text-xs text-slate-500">
              Invoice Faster. Get Paid Sooner.
            </span>
          </div>
        </div>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => {
            const active = activeTab === item.id;
            return (
              <button
                key={item.id}
                onClick={() => onTabChange(item.id)}
                className={[
                  "rounded-full px-6 mx-3 py-2 text-sm font-medium transition",
                  active
                    ? "bg-slate-900 text-white shadow-sm"
                    : "text-slate-600 hover:bg-slate-100",
                ].join(" ")}
                title={
                  item.locked
                    ? "Upgrade to Pro to unlock finance metrics"
                    : undefined
                }
              >
                {item.label}
                {item.locked && (
                  <span className="ml-2 text-xs font-normal text-amber-500">
                    🔒
                  </span>
                )}
              </button>
            );
          })}
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className="inline-flex items-center justify-center rounded-lg border border-slate-200 p-2 text-slate-700 hover:bg-slate-100 md:hidden"
          aria-label="Toggle navigation"
        >
          <div className="space-y-1.5">
            <span className="block h-0.5 w-5 bg-current" />
            <span className="block h-0.5 w-4 bg-current" />
            <span className="block h-0.5 w-5 bg-current" />
          </div>
        </button>
      </div>

      {open && (
        <nav className="border-t bg-white md:hidden">
          <div className="mx-auto flex max-w-6xl flex-col px-4 py-2">
            {navItems.map((item) => {
              const active = activeTab === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => {
                    onTabChange(item.id);
                    setOpen(false);
                  }}
                  className={[
                    "w-full rounded-xl px-3 py-2 text-left text-sm font-medium",
                    active
                      ? "bg-slate-900 text-white"
                      : "text-slate-700 hover:bg-slate-100",
                  ].join(" ")}
                  title={
                    item.locked
                      ? "Upgrade to Pro to unlock finance metrics"
                      : undefined
                  }
                >
                  {item.label}
                  {item.locked && " 🔒"}
                </button>
              );
            })}
          </div>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
